export class Case {
    id: number;
    //caseId: number;
    caseName:string;
    casePracticeId:number;
    healthSystem:any;
    patientId:number;
    patientName:string;
    caseDescription:string;
    caseTypeCodeItem:string;
    caseStatusCodeItem:string;
    state:string;
    caseOfIncident:Date;
    attorneyCaseNumber:string;
    comments:string;
    caseManagerId:number;
    legalPracticeId:number;
    legalPractice:any;
    patient:any;
    practitioner:any;
    authorUserId:number;
  }